import React, { useRef } from 'react';

export default function ImageUploader({ label, value, onChange }) {
  const inputRef = useRef();

  const handleFile = async (file) => {
    if (!file) return;
    const formData = new FormData();
    formData.append('image', file);

    try {
      const res = await fetch('/api/upload', { method: 'POST', body: formData });
      const json = await res.json();
      if (json.filename) {
        onChange(json.filename);
      }
    } catch (err) {
      console.error('Upload failed:', err);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file && file.type.startsWith('image/')) handleFile(file);
  };

  const handleDragOver = (e) => e.preventDefault();

  const imageSrc = value ? `/uploads/${value}` : null;

  return (
    <div className="control-group">
      <label className="control-label">{label}</label>
      <div
        className={`image-uploader ${value ? 'has-image' : ''}`}
        onClick={() => inputRef.current?.click()}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
      >
        {imageSrc ? (
          <>
            <img src={imageSrc} alt="Uploaded" />
            <button
              className="image-remove"
              onClick={(e) => { e.stopPropagation(); onChange(''); }}
            >×</button>
          </>
        ) : (
          <div className="upload-placeholder">
            <div className="upload-icon">📷</div>
            <div className="upload-text">Drop image or click to upload</div>
          </div>
        )}
        <input
          ref={inputRef}
          type="file"
          accept="image/*"
          style={{ display: 'none' }}
          onChange={(e) => handleFile(e.target.files[0])}
        />
      </div>
    </div>
  );
}
